/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import { dateToFormat, formatHour, formatHourSecond } from "../../utils/date";
import { get } from "lodash";
import { timepickerDefaultOptions } from "../../utils/dataComponent";
import { isEmpty } from "../../utils/lodashExtend";

const CustomDisplay = ({ defaultValue, inputRef, disabled }) => {
  return (
    <div className="timepicker-wrap">
      {disabled && <div className="disabled-wrap" />}
      <label ref={inputRef}>
        <span className="timepicker-label">
          {dateToFormat(defaultValue, formatHour) || "-"}
        </span>
        <input className="timepicker-input" defaultValue={defaultValue} />
      </label>
    </div>
  );
};

const TimePicker = (props) => {
  const {
    defaultValue,
    defaultPickerHour,
    onChange,
    isRange, // isRange 일경우 데이터는 {from,to} 아닐경우 key 그대로
    field,
    disabled,
    form
  } = props;
  const [startTime, setStartTime] = useState(
    dateToFormat('00:00:00', formatHourSecond)
  );
  const [endTime, setEndTime] = useState(
    dateToFormat('00:00:00', formatHourSecond)
  );

  useEffect(() => {
    if (!isEmpty(defaultValue)) {
      setStartTime(dateToFormat(defaultValue.from, formatHourSecond));
      setEndTime(dateToFormat(defaultValue.to, formatHourSecond));
    }
  }, []);

  const handleOnChange = (date, key) => {
    const _time = dateToFormat(date, formatHourSecond);

    const _key = `${field && field.key ? field.key : ''}${isRange && field && field.key ? '.' : ''}${isRange ? key : ''}`;
    if (key === "from") setStartTime(_time);
    if (key === "to") setEndTime(_time);

    if (onChange) {
      onChange({
        [_key]: _time
      });
    }
  };

  const getOptions = (type = "from") => {
    return {
      defaultValue: isRange ? (type === "from" ? startTime : endTime || dateToFormat('00:00:00', formatHourSecond)) : defaultValue,
      onChange: ([date]) => {
        isRange ? handleOnChange(date, type) : handleOnChange(date, field.key);
      },
      options: {
        ...timepickerDefaultOptions,
        defaultHour:
          (type === "from"
            ? get(defaultPickerHour, "from")
            : get(defaultPickerHour, "to")) || 12,
      },
    };
  };

  useEffect(() => {
    if (form && field && field?.key) {
      const data = get(form, `${field.key}`, {});
      if (form && field && field.key && !isEmpty(data) && !isEmpty(data.from)) {
        setStartTime(dateToFormat(data?.from, formatHourSecond));
        setEndTime(dateToFormat(data?.to, formatHourSecond));
      }
    }
  }, [form, field]);

  return (
    <>
      <Flatpickr
        render={({ defaultValue }, ref) => {
          return <CustomDisplay defaultValue={defaultValue} inputRef={ref} disabled={disabled} />;
        }}
        {...getOptions("from")}
      />
      {isRange && (
        <>
          <span className="date-separate">~</span>
          <Flatpickr
            render={({ defaultValue }, ref) => {
              return (
                <CustomDisplay defaultValue={defaultValue} inputRef={ref} disabled={disabled} />
              );
            }}
            {...getOptions("to")}
          />
        </>
      )}
    </>
  );
};

export default TimePicker;
